/**
 * @module utils/wait
 */

/**
 * @typedef {*} TimeoutValue
 */

/**
 * Awaits a promise after the provided delay, on the provided value
 * @param {Number} delay
 * @param {?TimeoutValue} value
 * @returns {Promise<TimeoutValue>}
 */
export default async (
  delay,
  value = undefined
) => {
  return new Promise(resolve => setTimeout(resolve, delay, value))
}
